import { DATEPICKER_DATE_MASK_TIME_LENGTH, DATEPICKER_DATE_MASK_DEFAULT_LENGTH } from '../../constants';
export var formatDateTimeMask = function formatDateTimeMask(val, enableTimePicker) {
  var digits = (val.match(/\d+/g) || []).join('');
  var alphabet = (val.match(/[a|p|m]/g) || []).join('');
  var maxLength = enableTimePicker ? DATEPICKER_DATE_MASK_TIME_LENGTH : DATEPICKER_DATE_MASK_DEFAULT_LENGTH;
  var chars = "".concat(digits).concat(alphabet).split('');
  var result = chars.reduce(function (r, v, index) {
    switch (true) {
      case index === 2 || index === 4:
        {
          return "".concat(r, ".").concat(v);
        }
      case index === 8 || index === 12:
        {
          return "".concat(r, " ").concat(v);
        }
      case index === 10:
        {
          return "".concat(r, ":").concat(v);
        }
      default:
        return "".concat(r).concat(v);
    }
  }, '').substring(0, maxLength);
  return "".concat(result);
};